export default (state, action) => {
  const { designId } = action.payload;
  return (designId)
    ? { ...state, selection: [designId] }
    : { ...state, selection: [] };
};
